<template>
  <section>
    <collapsable
      :collapsed="collapsed"
      :title="$t('menu.users')"
    >
    <span slot="beforeCollapse" class="d-flex align-items-center">
      <Searchable class="mr-2" :querySearch.sync="querySearch" />
    </span>

    <UsersTable
      ref="usersTable"
      :entity="entity"
      :querySearch="querySearch"
      :shouldShowFilters="false"
      :limit="25"
      :shouldShowLimit="false"
      :tableName="'entityUsersTable'"
      :saveState="false"
    />

    <div class="d-flex justify-content-end">
      <va-button v-if="hasWriteUsersPermissions"
        @click.prevent="createUser">
        {{ $t('users.create_user') }}
      </va-button>
    </div>

    </collapsable>

    <assign-roles-modal
      v-if="userWasRecentlyCreated"
      v-bind="assignRolesProps"
      @cancel="assignRolesModalClosed">
    </assign-roles-modal>

    <CreateOrUpdateUser
      v-if="hasWriteUsersPermissions && isCreatingUser"
      :entity="entity"
      @user-created="onUserCreated"
      @cancel="cancelCreateUser"
    />

  </section>
</template>
<script>
import UsersTable from '@/components/users/UsersTable'
import Searchable from '@/components/common/Searchable'
import Collapsable from '@/components/common/Collapsable'
import AssignRolesModal from '@/components/users/components/Roles/AssignRolesModal'
import CreateOrUpdateUser from '@/components/users/components/CreateOrUpdateUser'
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
import {TABLE_ENTITY_USERS} from "@/local-storage/LocalStorageKeys";
import EventBus from "@/utils/EventBus";

const usersInfoType = 100
const writeAccessType = 2

export default {
  mixins: [
    IndexTablesMixin
  ],
  components: {
    UsersTable,
    Searchable,
    Collapsable,
    AssignRolesModal,
    CreateOrUpdateUser,
    IndexTablesMixin
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    },
    hasWriteUsersPermissions: function () {
      return this.authService.user_permissions.some(p => p.info_type === usersInfoType && p.access_type === writeAccessType && (p.entity_id === null || p.entity_id === this.entity.id))
    }
  },
  data: function () {
    return {
      filters: {
        querySearch: '',
      },
      querySearch: '',
      isCreatingUser: false,
      userWasRecentlyCreated: false,
      assignRolesProps: {},
      customQueries: {},
      localStorageKey: TABLE_ENTITY_USERS
    }
  },
  methods: {
    createUser: function () {
      this.isCreatingUser = true
    },
    onUserCreated: function ({ user }) {
      this.userWasRecentlyCreated = true
      this.assignRolesProps.newUser = user
      this.$refs.usersTable.refresh()
      EventBus.$emit(`ENTITY_USER_CREATED_${this.entity.id}`)


    },
    assignRolesModalClosed: function () {
      this.userWasRecentlyCreated = false
      this.assignRolesProps = {}
    },
    cancelCreateUser: function () {
      this.isCreatingUser = false
    }
  }
}
</script>
